export default __webpack_public_path__ + "static/media/avtar-7.8c866027.png";